<script>
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import quoteMark from './images/quote-mark.svg';

	let {
		quote = '',
		name = '',
		label = null,
		href = null,
		popup = true,
		class: className = null,
	} = $props();
</script>

<div
	class={[
		className,
		'text-indow-grey-dark mb-8 flex flex-col rounded-lg p-4 shadow-lg',
	]}
>
	<div class="mb-2 w-7">
		<Image src={quoteMark} alt="&quot;" />
	</div>
	<p class="mb-0 px-4 text-center text-inherit">
		{quote}
	</p>

	<div class="mb-2 w-7 self-end">
		<Image src={quoteMark} alt="&quot;" class="rotate-180" />
	</div>

	<p class="text-right text-inherit">
		<span class="font-bold">&mdash; {name}</span>
		{#if href && label}
			<br /><a class="text-inherit italic" target={popup ? '_blank' : ''} {href}
				>{label}</a
			>
		{:else if label}
			<br /><span class="italic">{label}</span>
		{/if}
	</p>
</div>
